/**
 * Luxury PDP mobile sticky ATC — syncs total from [data-uf-lf-qty-savings-total]
 * and forwards clicks to .uf-lf-btn-cart. Visible ≤749px only (CSS).
 */
(function () {
  function initStickyAtc(root) {
    if (!root || root.getAttribute('data-uf-lf-sticky-ready') === '1') return;
    var bar = root.querySelector('[data-uf-lf-sticky-atc]');
    if (!bar) return;
    root.setAttribute('data-uf-lf-sticky-ready', '1');

    var totalSource = root.querySelector('[data-uf-lf-qty-savings-total]');
    var stickyTotal = bar.querySelector('[data-uf-lf-sticky-total]');
    var stickyBtn = bar.querySelector('[data-uf-lf-sticky-atc-btn]');
    var cartBtn = root.querySelector('.uf-lf-btn-cart');

    function syncTotal() {
      if (!stickyTotal) return;
      if (totalSource && totalSource.textContent) {
        stickyTotal.textContent = totalSource.textContent;
      }
    }

    function syncDisabled() {
      if (!stickyBtn || !cartBtn) return;
      stickyBtn.disabled = !!cartBtn.disabled;
    }

    syncTotal();
    syncDisabled();
    bar.removeAttribute('hidden');
    root.classList.add('uf-lf-product--sticky-atc');

    if (totalSource && typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(function () {
        syncTotal();
      });
      mo.observe(totalSource, { childList: true, characterData: true, subtree: true });
    }

    if (cartBtn && typeof MutationObserver !== 'undefined') {
      var moBtn = new MutationObserver(function () {
        syncDisabled();
        if (stickyBtn && cartBtn.textContent) {
          stickyBtn.textContent = cartBtn.textContent;
        }
      });
      moBtn.observe(cartBtn, { attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true });
    }

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var primary = root.querySelector('.uf-lf-btn-cart');
        if (!primary || primary.disabled) return;
        primary.click();
      });
    }
  }

  function boot() {
    document.querySelectorAll('.uf-lf-product[id^="uf-lf-product-"]').forEach(initStickyAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e && e.target;
    if (!section) return;
    var root = section.querySelector('.uf-lf-product[id^="uf-lf-product-"]');
    if (root) initStickyAtc(root);
  });
})();
